import styled from "styled-components";

export const PaginationContainer = styled.div`
    width: 100%;
    padding: 16px 13px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 1px 12px rgba(185, 185, 185, 0.08);
    display: flex;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
`;

export const Summary = styled.div`
    color: #001822;
    font-size: 14px;
    font-family: "Open Sans";
    font-weight: 400;
`;

export const PaginationNav = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PageButton = styled.button<{
    active?: boolean;
}>`
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid ${({ active }) => (active ? "#700AC1" : "#D6D6D6")};
    background: ${({ active }) => (active ? "#700AC1" : "#FFFFFF")};
    color: ${({ active }) => (active ? "#FFFFFF" : "#001822")};
    cursor: pointer;
    font-size: 14px;
    font-weight: ${({ active }) => (active ? 600 : 400)};
    box-shadow: ${({ active }) => (active ? "0 0 0 2px rgba(112, 10, 193, 0.18)" : "none")};
    &:hover {
        opacity: 0.9;
    }
`;

export const ArrowButton = styled(PageButton)`
    background: #ffffff;
    color: #001822;
    border: 1px solid #d6d6d6;
`;

export const RowsSection = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const RowsLabel = styled.div`
    color: #001822;
    font-size: 14px;
`;

export const RowsSelect = styled.select`
    width: 60px;
    height: 28px;
    border-radius: 6px;
    border: 1px solid #700ac1;
    background: #700ac1;
    color: white;
    padding: 0 8px;
    cursor: pointer;
`;
